import {
  addUpdateProductAPI,
  addUpdateUserAPI,
  addUserAPI,
  deleteIndividualCommissionEarningAPI,
  deleteIndividualPlatformChargesAPI,
  getAllCustomersAPI,
  getAllPharmacyRequestAPI,
  getAllProductAPI,
  getAllSupplierAPI,
  getCommisionEarningsAPI,
  getConsumerOrdersAPI,
  getHomeDataAPI,
  getMedicalCategoryAPI,
  getPharmacyStoreAPI,
  getPlatformChargesAPI,
  getQueriesAPI,
  getQueryDetailsAPI,
  getSearchDataAPI,
  getSearchSuggestionsAPI,
  getUniversalCustomerPlatformChargesAPI,
  getUserAPI,
  resolveQueryAPI,
  updateCustomersAPI,
  updatePharmacyRequestAPI,
  updatePharmacyStoreAPI,
  updateProductAPI,
  updateSupplierAPI,
  updateUniversalCommisionEarningAPI,
  updateUniversalCustomerPlatformChargesAPI,
  updateUniversalPlatformChargesAPI,
  updateUserActiveStatusAPI,
  updateUserAPI,
  upsertIndividualCommisionEarningAPI,
  upsertIndividualPlatformChargesAPI,
  upsertProductAPI,
  upsertUniversalCommisionEarningAPI,
  addDeliveryPartnerAPI,
  bulkAddProductReceivingAPI,
  getDeliveryPartnersAPI,
  updateDeliveryPartnerAPI,
  addDeliveryPartnerZoneAPI,
  getPharmacyInventoryAPI,
  updatePharmacyInventoryItemAPI,
  updateQueryStatusAPI,
  assignQueryAPI,
  updateQueryNotesAPI,
} from '../adapter/adapter'
import { PHARMACY_REQUEST_TYPE } from '../common/constant/page-constant'

export function getPharmacyDataHelper() {
  let promise = new Promise(function (resolve, reject) {
    getPharmacyStoreAPI()
      .then((res) => {
        console.log(res.data)

        if (res?.data?.error) {
          reject(res.data.error.message)
        } else if (res?.data?.data) {
          resolve(res.data.data)
        } else {
          reject('Get Pharmacy Failure')
        }
      })
      .catch((err) => {
        reject('Get Pharmacy Failure')
      })
  })

  return promise
}

export function updatePharmacyDataHelper(branchId, status) {
  let reqData = {
    branch_id: branchId,
    is_active: status,
  }
  let promise = new Promise(function (resolve, reject) {
    updatePharmacyStoreAPI(reqData)
      .then((res) => {
        console.log(res.data)

        if (res?.data?.error) {
          reject(res.data.error.message)
        } else if (res?.data?.data) {
          resolve(res.data.data)
        } else {
          reject('Get Pharmacy Failure')
        }
      })
      .catch((err) => {
        reject('Get Pharmacy Failure')
      })
  })

  return promise
}

export function bulkAddProductReceivingHelper(branchId, file) {
  let formData = new FormData()
  formData.append('file', file)
  formData.append('branch_id', branchId)

  let promise = new Promise(function (resolve, reject) {
    bulkAddProductReceivingAPI(formData)
      .then((res) => {
        console.log(res.data)

        if (res?.data?.error) {
          // Preserve the full error payload (message + row_errors + the
          // annotated error CSV) so the UI can offer a fixable file to download.
          reject(res.data.error)
        } else if (res?.data?.data) {
          resolve(res.data.data)
        } else {
          resolve(res.data)
        }
      })
      .catch((err) => {
        reject(
          err?.response?.data?.error || {
            message: err?.message || 'Bulk Add Product Receiving Failure',
          }
        )
      })
  })

  return promise
}

export function getAllCustomersHelper() {
  let promise = new Promise(function (resolve, reject) {
    getAllCustomersAPI()
      .then((res) => {
        console.log(res.data)

        if (res?.data?.error) {
          reject(res.data.error.message)
        } else if (res?.data?.data) {
          resolve(res.data.data)
        } else {
          reject('Get Customer Failure')
        }
      })
      .catch((err) => {
        reject('Get Customer Failure')
      })
  })

  return promise
}

export function getConsumerOrdersHelper(filters) {
  let promise = new Promise(function (resolve, reject) {
    getConsumerOrdersAPI(filters)
      .then((res) => {
        console.log(res.data)

        if (res?.data?.error) {
          reject(res.data.error.message)
        } else if (res?.data?.data) {
          resolve(res.data.data)
        } else {
          reject('Get Consumer Orders Failure')
        }
      })
      .catch((err) => {
        reject('Get Consumer Orders Failure')
      })
  })

  return promise
}

export function updateCustomerHelper(customerId, status) {
  let reqData = {
    customer_id: customerId,
    is_active: status,
  }

  let promise = new Promise(function (resolve, reject) {
    updateCustomersAPI(reqData)
      .then((res) => {
        console.log(res.data)

        if (res?.data?.error) {
          reject(res.data.error.message)
        } else if (res?.data?.data) {
          resolve(res.data.data)
        } else {
          reject('Get Customer Failure')
        }
      })
      .catch((err) => {
        reject('Get Customer Failure')
      })
  })

  return promise
}

export function getAllSuppliersHelper() {
  let promise = new Promise(function (resolve, reject) {
    getAllSupplierAPI()
      .then((res) => {
        console.log(res.data)

        if (res?.data?.error) {
          reject(res.data.error.message)
        } else if (res?.data?.data) {
          resolve(res.data.data)
        } else {
          reject('Get Supplier Failure')
        }
      })
      .catch((err) => {
        reject('Get Supplier Failure')
      })
  })

  return promise
}

export function updateSupplierHelper(data) {
  let reqData = {
    name: data.name,
    mobile_no: data.mobileNumber,
    address: data.address,
  }

  if (data.status) reqData.is_active = data.status
  if (data.id) reqData.supplier_id = data.id

  let promise = new Promise(function (resolve, reject) {
    updateSupplierAPI(reqData)
      .then((res) => {
        console.log(res.data)

        if (res?.data?.error) {
          reject(res.data.error.message)
        } else if (res?.data?.data) {
          resolve(res.data.data)
        } else {
          reject('Update Supplier Failure')
        }
      })
      .catch((err) => {
        reject('Update Supplier Failure')
      })
  })

  return promise
}

export function getUserHelper() {
  let promise = new Promise(function (resolve, reject) {
    getUserAPI()
      .then((res) => {
        console.log(res.data)

        if (res?.data?.error) {
          reject(res.data.error.message)
        } else if (res?.data?.data) {
          resolve(res.data.data)
        } else {
          reject('get User Failure')
        }
      })
      .catch((err) => {
        reject('get User Failure')
      })
  })

  return promise
}

export function updateUserActiveStatusHelper(data) {
  let reqData = {
    is_active: data?.status,
    crm_user_id: data?.id,
  }

  console.log(reqData)

  let promise = new Promise(function (resolve, reject) {
    updateUserActiveStatusAPI(reqData)
      .then((res) => {
        console.log(res.data)

        if (res?.data?.error) {
          reject(res.data.error.message)
        } else if (res?.data?.data && res?.data?.data) {
          resolve(res?.data?.data)
        } else {
          reject('Add User Failure !!')
        }
      })
      .catch((err) => {
        reject('Add User Failure !!')
      })
  })

  return promise
}

export function addUpdateUserHelper(data, action) {
  let reqData = {
    action: action,
    user: {
      user_id: data.userData?.id,
      name: data.userData?.name,
      email: data.userData?.email,
      mobile_no: data.userData?.mobileNumber,
      password: data.userData?.password,
      branch_id: data.userData?.branchId,
      designation: data.userData?.designation,
    },
    permissions: data?.permissionData,
  }

  console.log(reqData)

  let promise = new Promise(function (resolve, reject) {
    addUpdateUserAPI(reqData)
      .then((res) => {
        console.log(res.data)

        if (res?.data?.error) {
          reject(res.data.error.message)
        } else if (res?.data?.data && res?.data?.data?.is_completed) {
          resolve()
        } else {
          reject('Update User Failure !!')
        }
      })
      .catch((err) => {
        reject('Update User Failure !!')
      })
  })

  return promise
}

export function getSearchSuggestionsHelper(searchStr) {
  let reqData = {
    search_string: searchStr,
  }

  let promise = new Promise(function (resolve, reject) {
    getSearchSuggestionsAPI(reqData)
      .then((res) => {
        console.log(res.data)

        if (res?.data?.error) {
          reject(res.data.error.message)
        } else if (res?.data?.data) {
          resolve(res.data.data)
        } else {
          reject('Get Search Suggestions Failure')
        }
      })
      .catch((err) => {
        reject('Get Search Suggestions Failure')
      })
  })

  return promise
}

export function getSearchDataHelper(data) {
  let reqData = {
    search_id: data.id,
    type: data.type,
  }
  let promise = new Promise(function (resolve, reject) {
    getSearchDataAPI(reqData)
      .then((res) => {
        console.log(res.data)

        if (res?.data?.error) {
          reject(res.data.error.message)
        } else if (res?.data?.data) {
          resolve(res.data.data)
        } else {
          reject('Get Search Data Failure')
        }
      })
      .catch((err) => {
        reject('Get Search Data Failure')
      })
  })

  return promise
}

export function getAllProductHelper(data, params) {
  let promise = new Promise(function (resolve, reject) {
    getAllProductAPI(data, params)
      .then((res) => {
        if (res?.data?.error) {
          reject(res.data.error.message)
        } else if (res?.data) {
          resolve(res.data)
        } else {
          reject('Get Product Failure')
        }
      })
      .catch((err) => {
        reject('Get Product Failure')
      })
  })

  return promise
}

export function upsertProductHelper(data) {
  // let reqData = {
  //     action: action,
  //     ...data
  // }

  // console.log(reqData)

  // return
  let promise = new Promise(function (resolve, reject) {
    upsertProductAPI(data)
      .then((res) => {
        console.log(res.data)

        if (res?.data?.error) {
          reject(res.data.error.message)
        } else if (res?.data?.data && res?.data?.data) {
          resolve()
        } else {
          reject('Update User Failure !!')
        }
      })
      .catch((err) => {
        reject('Update User Failure !!')
      })
  })

  return promise
}

export function getMedicalCategoryHelper() {
  let promise = new Promise(function (resolve, reject) {
    getMedicalCategoryAPI()
      .then((res) => {
        console.log(res.data)

        if (res?.data?.error) {
          reject(res.data.error.message)
        } else if (res?.data?.data && res?.data?.data?.categories) {
          resolve(res.data.data?.categories)
        } else {
          reject('get products Failure')
        }
      })
      .catch((err) => {
        // reject('get products Failure')
        resolve([
          {
            label: 'MOUTH WASH',
            value: 'MOUTH WASH',
          },
          {
            label: 'GEL',
            value: 'GEL',
          },
          {
            label: 'EYE & NASAL DROPS',
            value: 'EYE & NASAL DROPS',
          },
          {
            label: 'SUSPENSION FOR INJECTION IN PREFILLED SYRINGE',
            value: 'SUSPENSION FOR INJECTION IN PREFILLED SYRINGE',
          },
        ])
      })
  })

  return promise
}

export function getAllPharmacyRequestHelper() {
  let promise = new Promise(function (resolve, reject) {
    getAllPharmacyRequestAPI()
      .then((res) => {
        console.log(res.data)

        if (res?.data?.error) {
          reject(res.data.error.message)
        } else if (res?.data?.data) {
          resolve(res.data.data)
        } else {
          reject('Get PharmacyRequest Failure')
        }
      })
      .catch((err) => {
        reject('Get PharmacyRequest Failure')
      })
  })

  return promise
}

export function updatePharmacyRequestHelper(data, type) {
  let reqData = {
    request_type: type,
    is_approved: data.status,
    product_id: type === PHARMACY_REQUEST_TYPE.PRODUCT && data.id,
    supplier_id: type === PHARMACY_REQUEST_TYPE.SUPPLIER && data.id,
  }

  console.log(reqData)

  let promise = new Promise(function (resolve, reject) {
    updatePharmacyRequestAPI(reqData)
      .then((res) => {
        console.log(res.data)

        if (res?.data?.error) {
          reject(res.data.error.message)
        } else if (res?.data?.data && res?.data?.data) {
          resolve()
        } else {
          reject('Update User Failure !!')
        }
      })
      .catch((err) => {
        reject('Update User Failure !!')
      })
  })

  return promise
}

export function getCommisionEarningsHelper() {
  let promise = new Promise(function (resolve, reject) {
    getCommisionEarningsAPI()
      .then((res) => {
        console.log(res.data)

        if (res?.data?.error) {
          reject(res.data.error.message)
        } else if (res?.data?.data && res?.data?.data) {
          resolve(res.data.data)
        } else {
          reject('get Commision Earnings API Failure !!')
        }
      })
      .catch((err) => {
        reject('get Commision Earnings API Failure !!')
      })
  })

  return promise
}

export function updateUniversalCommisionEarningsHelper(commision) {
  let reqData = {
    commission: commision,
  }

  let promise = new Promise(function (resolve, reject) {
    updateUniversalCommisionEarningAPI(reqData)
      .then((res) => {
        console.log(res.data)

        if (res?.data?.error) {
          reject(res.data.error.message)
        } else if (res?.data?.data && res?.data?.data) {
          resolve(res.data.data)
        } else {
          reject('update Commision Earnings API Failure !!')
        }
      })
      .catch((err) => {
        reject('update Commision Earnings API Failure !!')
      })
  })

  return promise
}

export function upsertIndividualCommisionEarningHelper(data) {
  let reqData = {
    updated_data: data,
  }
  let promise = new Promise(function (resolve, reject) {
    upsertIndividualCommisionEarningAPI(reqData)
      .then((res) => {
        console.log(res.data)

        if (res?.data?.error) {
          reject(res.data.error.message)
        } else if (res?.data?.data && res?.data?.data) {
          resolve(res.data.data)
        } else {
          reject('upsert Commision Earnings API Failure !!')
        }
      })
      .catch((err) => {
        reject('upsert Commision Earnings API Failure !!')
      })
  })

  return promise
}

export function deleteUniversalCommisionEarningHelper(id) {
  let reqData = {
    id: id,
  }
  let promise = new Promise(function (resolve, reject) {
    deleteIndividualCommissionEarningAPI(reqData)
      .then((res) => {
        console.log(res.data)

        if (res?.data?.error) {
          reject(res.data.error.message)
        } else if (res?.data?.data && res?.data?.data) {
          resolve(res.data.data)
        } else {
          reject('delete Commision Earnings API Failure !!')
        }
      })
      .catch((err) => {
        reject('delete Commision Earnings API Failure !!')
      })
  })

  return promise
}

export function getPlatformChargesHelper() {
  let promise = new Promise(function (resolve, reject) {
    getPlatformChargesAPI()
      .then((res) => {
        console.log(res.data)

        if (res?.data?.error) {
          reject(res.data.error.message)
        } else if (res?.data?.data && res?.data?.data) {
          resolve(res.data.data)
        } else {
          reject('get Platform Charges API Failure !!')
        }
      })
      .catch((err) => {
        reject('get Platform Charges API Failure !!')
      })
  })

  return promise
}

export function updateUniversalPlatformChargesHelper(commision) {
  let reqData = {
    commission: commision,
  }

  let promise = new Promise(function (resolve, reject) {
    updateUniversalPlatformChargesAPI(reqData)
      .then((res) => {
        console.log(res.data)

        if (res?.data?.error) {
          reject(res.data.error.message)
        } else if (res?.data?.data && res?.data?.data) {
          resolve(res.data.data)
        } else {
          reject('update Platform Charges API Failure !!')
        }
      })
      .catch((err) => {
        reject('update Platform Charges API Failure !!')
      })
  })

  return promise
}

export function getCustomerPlatformChargesHelper() {
  let promise = new Promise(function (resolve, reject) {
    getUniversalCustomerPlatformChargesAPI()
      .then((res) => {
        console.log(res.data)

        if (res?.data?.error) {
          reject(res.data.error.message)
        } else if (res?.data?.data && res?.data?.data) {
          resolve(res.data.data)
        } else {
          reject('get Platform Charges API Failure !!')
        }
      })
      .catch((err) => {
        reject('get Platform Charges API Failure !!')
      })
  })

  return promise
}

export function updateCustomerPlatformChargesHelper(commision) {
  let reqData = {
    commission: commision,
  }

  let promise = new Promise(function (resolve, reject) {
    updateUniversalCustomerPlatformChargesAPI(reqData)
      .then((res) => {
        console.log(res.data)

        if (res?.data?.error) {
          reject(res.data.error.message)
        } else if (res?.data?.data && res?.data?.data) {
          resolve(res.data.data)
        } else {
          reject('update Platform Charges API Failure !!')
        }
      })
      .catch((err) => {
        reject('update Platform Charges API Failure !!')
      })
  })

  return promise
}

export function upsertIndividualPlatformChargesHelper(data) {
  let reqData = {
    updated_data: data,
  }
  let promise = new Promise(function (resolve, reject) {
    upsertIndividualPlatformChargesAPI(reqData)
      .then((res) => {
        console.log(res.data)

        if (res?.data?.error) {
          reject(res.data.error.message)
        } else if (res?.data?.data && res?.data?.data) {
          resolve(res.data.data)
        } else {
          reject('upsert Platform Charges API Failure !!')
        }
      })
      .catch((err) => {
        reject('upsert Platform Charges API Failure !!')
      })
  })

  return promise
}

export function deleteIndividualPlatformChargesHelper(id) {
  let reqData = {
    id: id,
  }
  let promise = new Promise(function (resolve, reject) {
    deleteIndividualPlatformChargesAPI(reqData)
      .then((res) => {
        console.log(res.data)

        if (res?.data?.error) {
          reject(res.data.error.message)
        } else if (res?.data?.data && res?.data?.data) {
          resolve(res.data.data)
        } else {
          reject('delete Platform Charges API Failure !!')
        }
      })
      .catch((err) => {
        reject('delete Platform Charges API Failure !!')
      })
  })

  return promise
}

export function getHomeDataHelper(startDate, endDate) {
  let reqData = {
    start_date: startDate,
    end_date: endDate,
  }

  let promise = new Promise(function (resolve, reject) {
    getHomeDataAPI(reqData)
      .then((res) => {
        console.log(res.data)

        if (res?.data?.error) {
          reject(res.data.error.message)
        } else if (res?.data?.data && res?.data?.data) {
          resolve(res.data.data)
        } else {
          reject('get Home Data API Failure !!')
        }
      })
      .catch((err) => {
        reject('get Home Data API Failure !!')
      })
  })

  return promise
}

export function getQueriesHelper(startDate, endDate) {
  let reqData = {
    start_date: startDate,
    end_date: endDate,
  }

  let promise = new Promise(function (resolve, reject) {
    getQueriesAPI(reqData)
      .then((res) => {
        console.log(res.data)

        if (res?.data?.error) {
          reject(res.data.error.message)
        } else if (res?.data?.data && res?.data?.data) {
          resolve(res.data.data)
        } else {
          reject('get Queries API Failure !!')
        }
      })
      .catch((err) => {
        reject('get Queries API Failure !!')
      })
  })

  return promise
}

export function getQueryDetailsHelper(query) {
  let reqData = {
    query_no: query.query_no,
    user_type: query.user_type,
  }

  let promise = new Promise(function (resolve, reject) {
    getQueryDetailsAPI(reqData)
      .then((res) => {
        console.log(res.data)

        if (res?.data?.error) {
          reject(res.data.error.message)
        } else if (res?.data?.data && res?.data?.data) {
          resolve(res.data.data)
        } else {
          reject('get Query Details API Failure !!')
        }
      })
      .catch((err) => {
        reject('get Query Details API Failure !!')
      })
  })

  return promise
}

export function resolveQueryHelper(query) {
  let reqData = {
    query_no: query.query_no,
    user_type: query.user_type,
  }

  let promise = new Promise(function (resolve, reject) {
    resolveQueryAPI(reqData)
      .then((res) => {
        console.log(res.data)

        if (res?.data?.error) {
          reject(res.data.error.message)
        } else if (res?.data?.data && res?.data?.data) {
          resolve(res.data.data)
        } else {
          reject('resolve Query API Failure !!')
        }
      })
      .catch((err) => {
        reject('resolve Query API Failure !!')
      })
  })

  return promise
}

export function addDeliveryPartnerHelper(data) {
  let promise = new Promise(function (resolve, reject) {
    addDeliveryPartnerAPI(data)
      .then((res) => {
        console.log(res.data)

        if (res?.data?.error) {
          reject(res.data.error.message)
        } else if (res?.data?.data) {
          resolve(res.data.data)
        } else {
          reject('Add Delivery Partner Failure')
        }
      })
      .catch((err) => {
        reject('Add Delivery Partner Failure')
      })
  })

  return promise
}

export function getDeliveryPartnersHelper() {


  let promise = new Promise(function (resolve, reject) {
    getDeliveryPartnersAPI()
      .then((res) => {
        console.log(res.data)

        if (res?.data?.error) {
          reject(res.data.error.message)
        } else if (res?.data?.data) {
          resolve(res.data.data)
        } else {
          reject('Get Delivery Partners Failure')
        }
      })
      .catch((err) => {
        reject('Get Delivery Partners Failure')
      })
  })

  return promise
}



export function updateDeliveryPartnerHelper(data) {
  let promise = new Promise(function (resolve, reject) {
    updateDeliveryPartnerAPI(data)
      .then((res) => {
        console.log(res.data)

        if (res?.data?.error) {
          reject(res.data.error.message)
        } else if (res?.data?.data) {
          resolve(res.data.data)
        } else {
          reject('Update Delivery Partner Failure')
        }
      })
      .catch((err) => {
        reject('Update Delivery Partner Failure')
      })
  })

  return promise
}
export function addDeliveryPartnerZoneHelper(data) {
  let promise = new Promise(function (resolve, reject) {
    addDeliveryPartnerZoneAPI(data)
      .then((res) => {
        console.log(res.data)

        if (res?.data?.error) {
          reject(res.data.error.message)
        } else if (res?.data?.data) {
          resolve(res.data.data)
        } else {
          reject('Add Delivery Partner Zone Failure')
        }
      })
      .catch((err) => {
        reject('Add Delivery Partner Zone Failure')
      })
  })

  return promise
}

export function getPharmacyInventoryHelper(data, params) {
  let promise = new Promise(function (resolve, reject) {
    getPharmacyInventoryAPI(data, params)
      .then((res) => {
        if (res?.data?.error) {
          reject(res.data.error.message)
        } else if (res?.data) {
          resolve(res.data)
        } else {
          reject('Get Pharmacy Inventory Failure')
        }
      })
      .catch((err) => {
        reject('Get Pharmacy Inventory Failure')
      })
  })

  return promise
}

export function updatePharmacyInventoryItemHelper(data) {
  let promise = new Promise(function (resolve, reject) {
    updatePharmacyInventoryItemAPI(data)
      .then((res) => {
        if (res?.data?.error) {
          reject(res.data.error.message)
        } else if (res?.data?.data) {
          resolve(res.data.data)
        } else {
          reject('Update Inventory Item Failure')
        }
      })
      .catch((err) => {
        reject('Update Inventory Item Failure')
      })
  })

  return promise
}

export function updateQueryStatusHelper(queryNo, userType, status) {
  let reqData = {
    query_no: queryNo,
    user_type: userType,
    status: status,
  }

  let promise = new Promise(function (resolve, reject) {
    updateQueryStatusAPI(reqData)
      .then((res) => {
        if (res?.data?.error) {
          reject(res.data.error.message)
        } else if (res?.data?.data) {
          resolve(res.data.data)
        } else {
          reject('Update Query Status Failure')
        }
      })
      .catch((err) => {
        reject('Update Query Status Failure')
      })
  })

  return promise
}

export function assignQueryHelper(queryNo, userType, crmUserId) {
  let reqData = {
    query_no: queryNo,
    user_type: userType,
    crm_user_id: crmUserId,
  }

  let promise = new Promise(function (resolve, reject) {
    assignQueryAPI(reqData)
      .then((res) => {
        if (res?.data?.error) {
          reject(res.data.error.message)
        } else if (res?.data?.data) {
          resolve(res.data.data)
        } else {
          reject('Assign Query Failure')
        }
      })
      .catch((err) => {
        reject('Assign Query Failure')
      })
  })

  return promise
}

export function updateQueryNotesHelper(queryNo, userType, noteText) {
  let reqData = {
    query_no: queryNo,
    user_type: userType,
    note_text: noteText,
  }

  let promise = new Promise(function (resolve, reject) {
    updateQueryNotesAPI(reqData)
      .then((res) => {
        if (res?.data?.error) {
          reject(res.data.error.message)
        } else if (res?.data?.data) {
          resolve(res.data.data)
        } else {
          reject('Update Query Notes Failure')
        }
      })
      .catch((err) => {
        reject('Update Query Notes Failure')
      })
  })

  return promise
}
